import React from 'react';
import styled from 'styled-components';
import { Logo as LogoIcon } from '@/assets/icons';
import { useTranslation } from 'react-i18next';
import { NAVBAR_HEIGHT } from '@/config/variables';

const LargeLoader = (): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Container>
      <Logo />
      <Title>{t`commonComponents.loaders.largeTitle`}</Title>
      <BottomText>{t`commonComponents.loaders.largeBottomText`}</BottomText>
      <Dots>
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
      </Dots>
    </Container>
  );
};

export { LargeLoader };

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
  background-color: #ffffff;
`;

const Logo = styled.div`
  width: 72px !important;
  height: 72px !important;
  margin-bottom: 0.5rem;
  background-color: #0a4599;
  mask-image: url(${LogoIcon});
  mask-repeat: no-repeat;
  mask-position: left;
  mask-size: contain;
`;

const Title = styled.div`
  color: #374151;
  line-height: 1.4;
  margin-bottom: 0.5rem;
`;

const BottomText = styled.div`
  color: #374151;
  line-height: 1.2;
  font-size: 0.75rem;
`;

const Dots = styled.div`
  margin-top: 2rem;

  .dot {
    display: inline-block;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    background: #0a4599;
    animation: loading 1s alternate infinite;
    margin-right: 0.75rem;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }

    &:nth-child(4) {
      animation-delay: 0.6s;
    }
  }

  @keyframes loading {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
